import { Card, Row, Col } from "antd";
import { Typography } from "antd";
const { Title, Paragraph, Text, Link } = Typography;

const Mission = () => {
  return (
    <div className="py-10">
      <h2 className="text-2xl font-bold mb-6 ">Our Goals & Trajectory</h2>
      <div
        className=" h-[120px] text-center p-2"
        style={{
          background: "#FAFAFA 0% 0% no-repeat padding-box",
          boxShadow: "0px 3px 6px #0000000D",
          borderRadius: "8px",
        }}
      >
        {/* <Typography> */}
        <p className="mt-2 ml-2 text-lg font-normal text-left">
          At DevXOps, we are pioneering a transformative technological ecosystem
          that seamlessly integrates cutting-edge DevOps practices, advanced
          technologies, and innovative solutions. Our mission is to empower
          organizations to transcend traditional technological boundaries by
          creating intelligent, adaptive, and interconnected digital landscapes
          that drive unprecedented business growth and technological innovation.
        </p>
        {/* </Typography> */}
      </div>
    </div>
  );
};

export default Mission;
